import { z } from "zod";
const MetronomeErrorCode = {
  METRONOME_UNAVAILABLE: "METRONOME_UNAVAILABLE",
  NOT_FOUND: "NOT_FOUND"
};
const MetronomeResourceType = {
  CUSTOMER: "customer",
  CONTRACT: "contract",
  INVOICE: "invoice"
};
const metronomeErrorResponseSchema = z.discriminatedUnion("errorCode", [
  z.object({
    errorCode: z.literal(MetronomeErrorCode.METRONOME_UNAVAILABLE),
    message: z.string(),
    status: z.literal("service_unavailable")
  }),
  z.object({
    errorCode: z.literal(MetronomeErrorCode.NOT_FOUND),
    message: z.string(),
    resourceType: z.enum(MetronomeResourceType),
    status: z.literal("not_found")
  })
]);
function resolvePeriodCreditCapacity(period) {
  return period.balances.kind === "live" ? period.credits_used - period.credits_overage + period.balances.remaining_ai_credits : null;
}
export {
  MetronomeErrorCode,
  MetronomeResourceType,
  metronomeErrorResponseSchema,
  resolvePeriodCreditCapacity
};
//# sourceMappingURL=metronome.js.map
